// Opens the calendar on a useful hour instead of midnight.

// How much we keep visible above the anchor, so it's not glued to the top edge.
const LEAD_HOURS = 1;

// Survives the day/week switch, which swaps out the container. Stored as an
// hour and not pixels, the two grids start at different offsets.
let rememberedHour = null;

// Everything else works off these two: where 0:00 sits inside the scroll
// content, and how tall an hour ends up being on screen.
function measure(container) {
  const zero = container.querySelector('[data-hour="0"]');
  const one = container.querySelector('[data-hour="1"]');
  if (!zero || !one) return null;

  const zeroViewportTop = zero.getBoundingClientRect().top;
  const hourPx = one.getBoundingClientRect().top - zeroViewportTop;
  if (hourPx <= 0) return null;

  const zeroTop = zeroViewportTop - container.getBoundingClientRect().top + container.scrollTop;

  return { zeroTop, hourPx };
}

export default {
  CalendarScroll: {
    mounted() {
      this.remeasure();

      const anchor = rememberedHour ?? parseFloat(this.el.dataset.anchorHour);
      if (this.geometry && Number.isFinite(anchor)) this.scrollToHour(anchor);

      // Reads the cached geometry, so nothing forces a layout while scrolling.
      this.onScroll = () => {
        if (this.geometry) rememberedHour = this.currentHour();
      };
      this.el.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.remeasure());
      this.resizeObserver.observe(this.el);
    },

    // All-day events make the header taller, which pushes hour 0 down. The
    // container itself keeps its size though, so no resize callback fires.
    updated() {
      this.remeasure();
    },

    destroyed() {
      if (this.onScroll) this.el.removeEventListener('scroll', this.onScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    },

    remeasure() {
      this.geometry = measure(this.el) ?? this.geometry;
    },

    scrollToHour(hour) {
      const { zeroTop, hourPx } = this.geometry;

      this.el.scrollTop = Math.max(0, Math.round(zeroTop + (hour - LEAD_HOURS) * hourPx));
    },

    currentHour() {
      const { zeroTop, hourPx } = this.geometry;
      const hour = (this.el.scrollTop - zeroTop) / hourPx + LEAD_HOURS;

      // scrollTop stops at both ends, so the raw number can land outside 0-24.
      return Math.min(Math.max(hour, 0), 24);
    },
  },
};
